function FloatingActionButton({
  onClick,
  ariaLabel = "Add",
  icon = "add",
  className = "",
}) {
  const classes = className ? `shared-fab ${className}` : "shared-fab";

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <span className="material-symbols-outlined">{icon}</span>
    </button>
  );
}

export default FloatingActionButton;
